
import { defineComponent } from "vue";
import SiteTitle from "@/components/SiteTitle.vue";

export default defineComponent({
  name: "About",
  components: { SiteTitle },
  setup() {
    //
  }
});
